<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>createdAt</td>
            <td>{{ item['createdAt'] }}</td>
          </tr>
          <tr>
            <td>updatedAt</td>
            <td>{{ item['updatedAt'] }}</td>
          </tr>
          <tr>
            <td>deletedAt</td>
            <td>{{ item['deletedAt'] }}</td>
          </tr>
          <tr>
            <td>createdBy</td>
            <td>{{ item['createdBy'] }}</td>
          </tr>
          <tr>
            <td>updatedBy</td>
            <td>{{ item['updatedBy'] }}</td>
          </tr>
          <tr>
            <td>deletedBy</td>
            <td>{{ item['deletedBy'] }}</td>
          </tr>
          <tr>
            <td>state</td>
            <td>{{ item['state'] }}</td>
          </tr>
          <tr>
            <td>titlePartOne</td>
            <td>{{ item['titlePartOne'] }}</td>
          </tr>
          <tr>
            <td>titlePartTwo</td>
            <td>{{ item['titlePartTwo'] }}</td>
          </tr>
          <tr>
            <td>contactPerson</td>
            <td>{{ item['contactPerson'] }}</td>
          </tr>
          <tr>
            <td>representativePerson</td>
            <td>{{ item['representativePerson'] }}</td>
          </tr>
          <tr>
            <td>nip</td>
            <td>{{ item['nip'] }}</td>
          </tr>
          <tr>
            <td>phone</td>
            <td>{{ item['phone'] }}</td>
          </tr>
          <tr>
            <td>mobilePhone</td>
            <td>{{ item['mobilePhone'] }}</td>
          </tr>
          <tr>
            <td>userEmail</td>
            <td>{{ item['userEmail'] }}</td>
          </tr>
          <tr>
            <td>street</td>
            <td>{{ item['street'] }}</td>
          </tr>
          <tr>
            <td>city</td>
            <td>{{ item['city'] }}</td>
          </tr>
          <tr>
            <td>postcode</td>
            <td>{{ item['postcode'] }}</td>
          </tr>
          <tr>
            <td>province</td>
            <td>{{ item['province'] }}</td>
          </tr>
          <tr>
            <td>country</td>
            <td>{{ item['country'] }}</td>
          </tr>
          <tr>
            <td>extraInfo</td>
            <td>{{ item['extraInfo'] }}</td>
          </tr>
          <tr>
            <td>bankName</td>
            <td>{{ item['bankName'] }}</td>
          </tr>
          <tr>
            <td>bankAccount</td>
            <td>{{ item['bankAccount'] }}</td>
          </tr>
          <tr>
            <td>smsKey</td>
            <td>{{ item['smsKey'] }}</td>
          </tr>
          <tr>
            <td>logo</td>
            <td>{{ item['logo'] }}</td>
          </tr>
          <tr>
            <td>ownerType</td>
            <td>{{ item['ownerType'] }}</td>
          </tr>
          <tr>
            <td>onBehalfStatus</td>
            <td>{{ item['onBehalfStatus'] }}</td>
          </tr>
          <tr>
            <td>onBehalfEmail</td>
            <td>{{ item['onBehalfEmail'] }}</td>
          </tr>
          <tr>
            <td>replyToEmail</td>
            <td>{{ item['replyToEmail'] }}</td>
          </tr>
          <tr>
            <td>longitude</td>
            <td>{{ item['longitude'] }}</td>
          </tr>
          <tr>
            <td>latitude</td>
            <td>{{ item['latitude'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      v-if="item"
      :to="{ name: 'EXSBOwnerList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deleteError: 'exsbowner/del/error',
    error: 'exsbowner/show/error',
    isLoading: 'exsbowner/show/isLoading',
    item: 'exsbowner/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'exsbowner/del/del',
      reset: 'exsbowner/show/reset',
      retrieve: 'exsbowner/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBOwnerList' }))
      }
    }
  }
}
</script>
